import { useEffect, useState } from 'react'

/** Layout breakpoints aligned with Figma: L (md), XL (lg), 2XL (xl). */
export const BP = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
  wide: 1536,
} as const

const desktopMediaQuery = `(min-width: ${BP.desktop}px)`
const xlMediaQuery = `(min-width: ${BP.tablet}px) and (max-width: ${BP.desktop - 1}px)`

export const getIsDesktopMatch = (): boolean => {
  if (typeof window === 'undefined') return false
  return window.matchMedia(desktopMediaQuery).matches
}

export const getIsXlMatch = (): boolean => {
  if (typeof window === 'undefined') return false
  return window.matchMedia(xlMediaQuery).matches
}

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  )

  useEffect(() => {
    const mql = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}

export const useIsMobile = (): boolean => useMediaQuery(`(max-width: ${BP.mobile - 1}px)`)

export const useIsTablet = (): boolean =>
  useMediaQuery(`(min-width: ${BP.mobile}px) and (max-width: ${BP.tablet - 1}px)`)

/** L (768–1023): icon rail when collapsed, Sheet overlay when open. */
export const useIsOverlaySidebar = (): boolean => useIsTablet()

/** XL (1024–1279): inline expanded/collapsed sidebar — no Sheet overlay. */
export const useIsXlSidebar = (): boolean => useMediaQuery(xlMediaQuery)
